import useCaseTypeHook from 'hooks/modules/mdm/useCaseTypeHook';
import useFormOptionHook from 'hooks/modules/mdm/useFormOption';
import useLocationHook from 'hooks/modules/mdm/useLocationHook';
import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';

interface MainLayoutContextInterface {
  contentClass: string;
  setContentClass: Dispatch<SetStateAction<string>>;
  footerClass: string;
  setFooterClass: Dispatch<SetStateAction<string>>;
}

export const MainLayoutContext = createContext(
  {} as MainLayoutContextInterface
);

const MainLayoutProvider = ({ children }: PropsWithChildren) => {
  const [contentClass, setContentClass] = useState('');
  const [footerClass, setFooterClass] = useState('');

  // initial call api
  const { formOptions, fetchAllFormOption } = useFormOptionHook();
  const { caseTypes, fetchAllCaseType } = useCaseTypeHook();
  const {
    fetchAllLocation,
    fetchAllLocationWithTree,
    treeLocations,
    locations
  } = useLocationHook();

  useEffect(() => {
    if (formOptions.length <= 0) {
      fetchAllFormOption().catch(e => console.log(e));
    }
    if (locations.length <= 0) {
      fetchAllLocation().catch(e => console.log(e));
    }
    if (treeLocations.length <= 0) {
      fetchAllLocationWithTree().catch(e => console.log(e));
    }
    if (caseTypes.length <= 0) {
      fetchAllCaseType().catch(e => console.log(e));
    }
  }, []);
  return (
    <MainLayoutContext.Provider
      value={{ contentClass, setContentClass, footerClass, setFooterClass }}
    >
      {children}
    </MainLayoutContext.Provider>
  );
};

export const useMainLayoutContext = () => useContext(MainLayoutContext);

export default MainLayoutProvider;
